/**
 * Calculate the player's total score across every round.
 * @param roundScores Score achieved by the player each round.
 * @returns           Total score across all rounds.
 */
export default function (roundScores: RoundScore[][]): number {
    let score = 0;
    roundScores.forEach(function (roundScore: RoundScore[]): void {
        roundScore.forEach(function (oneRoundScore: RoundScore): void {
            score += oneRoundScore.score;
        });
    });
    return score;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/globals/utilities/calculate-total-score.ts